<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell" :class="{'weui-cell_select weui-cell_select-after':!form.id}">
          <div class="weui-cell__hd">
            <label for class="weui-label">科目类别</label>
          </div>
          <div class="weui-cell__bd">
            <span v-if="form.id">{{form.ca_class}}</span>
            <select v-else class="weui-select" v-model="form.ca_class" @change="onSelectClass">
              <option>资产</option>
              <option>负债</option>
              <option>所有者权益</option>
              <option>成本</option>
              <option>损益</option>
            </select>
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">余额方向</label>
          </div>
          <div class="weui-cell__bd">
            <select class="weui-select" v-model="form.ca_balancetype" placeholder="请选择">
              <option>借</option>
              <option>贷</option>
            </select>
          </div>
        </div>
        <div class="weui-cell" v-if="form.ca_pcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">上级科目</label>
          </div>
          <div class="weui-cell__bd">{{form.ca_pcode}}&nbsp;{{form.ca_pname}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">科目编号</label>
          </div>
          <div class="weui-cell__bd">
            <span v-if="form.id">{{form.ca_code}}</span>
            <input v-else class="weui-input" type="text" v-model="form.ca_code" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">科目名称</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.ca_name" placeholder="请填写" />
          </div>
        </div>
        <check-group-field label="辅助核算" :items="assTypes" v-model="form.ca_ass" />
        <currency-field
          label="外币核算"
          :extra-items="currencyTypes"
          :no-default="true"
          v-model="form.ca_currency"
          @select="onSelectCurrency"
        />
        <div class="weui-cell weui-cell_active weui-cell_switch" v-if="form.ca_currency">
          <div class="weui-cell__bd">期末调汇</div>
          <div class="weui-cell__ft">
            <input
              class="weui-switch"
              v-model="form.ca_israteadj"
              type="checkbox"
              v-bind:true-value="1"
              v-bind:false-value="0"
            />
          </div>
        </div>
        <div class="weui-cell weui-cell_active weui-cell_switch">
          <div class="weui-cell__bd">现金及现金等价物</div>
          <div class="weui-cell__ft">
            <input
              class="weui-switch"
              v-model="form.ca_iscash"
              type="checkbox"
              v-bind:true-value="1"
              v-bind:false-value="0"
            />
          </div>
        </div>
        <div class="weui-cell" v-if="isBank">
          <div class="weui-cell__hd">
            <label for class="weui-label">开户银行</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.ca_bank" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell" v-if="isBank">
          <div class="weui-cell__hd">
            <label for class="weui-label">银行账号</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.ca_bankaccount" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell weui-cell_active weui-cell_switch">
          <div class="weui-cell__bd">默认收付款账户</div>
          <div class="weui-cell__ft">
            <input
              class="weui-switch"
              v-model="form.ca_isdefaultaccount"
              type="checkbox"
              v-bind:true-value="1"
              v-bind:false-value="0"
            />
          </div>
        </div>
        <cashflow-field v-model="form.ca_cashname" @select="onSelectCashflow" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import CheckGroupField from "@/components/field/CheckGroupField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import CashflowField from "@/components/field/CashflowField.vue";
import form from "@/mixins/form.js";

export default {
  components: {
    CheckGroupField,
    CurrencyField,
    CashflowField
  },
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/finance/category",
      form: {
        ca_class: "资产",
        ca_level: 1,
        ca_balancetype: "借",
        ca_code: null,
        ca_pcode: null,
        ca_ass: null,
        ca_currency: null,
        ca_israteadj: 0,
        ca_iscash: 0,
        ca_isdefaultaccount: 0,
        ca_cashname: null,
        ca_bankaccount: null,
        ca_bank: null
      },
      assTypes: [
        {
          display: "客户",
          value: "Cust"
        },
        {
          display: "供应商",
          value: "Vend"
        },
        {
          display: "部门",
          value: "Dept"
        },
        {
          display: "员工",
          value: "Empl"
        },
        {
          display: "项目",
          value: "Project"
        }
      ],
      currencyTypes: [
        {
          cr_name: null,
          display: "不核算外币"
        },
        {
          cr_name: "ALL",
          display: "核算所有外币"
        }
      ]
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.readonly && !vm.$route.query.id) {
        if (to.params.parent) {
          vm.initWithParent();
        }
        vm.generateCode();
      }
    });
  },
  computed: {
    isBank() {
      var me = this, main = me.form, title = '银行存款', parent = me.$route.params.parent;
      if (main.ca_name && main.ca_name.indexOf(title) > -1) {
        return true;
      }
      if (main.ca_desc && main.ca_desc.indexOf(title) > -1) {
        return true;
      }
      if (parent && parent.ca_desc.indexOf(title) > -1) {
        return true;
      }
      return !!main.ca_bankaccount;
    }
  },
  methods: {
    save() {
      var me = this,
        main = me.form;
      if (!main.ca_code) {
        me.$weui.topTips("请填写科目编号", 2000);
      } else if (!main.ca_name) {
        me.$weui.topTips("请填写科目名称", 2000);
      } else {
        me.f_save();
      }
    },
    onSelectCurrency(selection) {
      if (!selection.cr_name) {
        // 不做外币核算时，不用期末调汇
        this.form.ca_israteadj = false;
      }
    },
    onSelectCashflow(selection) {
      this.form.ca_cashcode = selection.itemCode;
    },
    onSelectClass() {
      /**
       * 新增1级科目时，修改科目类别后，重新生成科目号；
       * 新增2级以上科目是固定了类别的
       */
      var me = this;
      if (!me.readonly && !me.$route.query.id && me.form.ca_level == 1) {
        me.generateCode();
      }
    },
    /**
     * 生成科目号
     */
    generateCode() {
      var me = this,
        main = me.form;
      me.$ajax({
        url: me.baseUrl + "/generateCode",
        params: {
          ca_class: main.ca_class,
          ca_level: main.ca_level,
          parentCode: main.ca_pcode
        }
      }).then(function(res) {
        if (res.success) {
          main.ca_code = res.data;
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    },
    /**
     * 新增下级科目的情况
     */
    initWithParent() {
      var me = this,
        main = me.form,
        parent = me.$route.params.parent;
      main.ca_class = parent.ca_class;
      main.ca_level = parent.ca_level + 1;
      main.ca_pcaid = parent.id;
      main.ca_pcode = parent.ca_code;
      main.ca_pname = parent.ca_name;
      main.ca_balancetype = parent.ca_balancetype;
      main.ca_iscash = parent.ca_iscash;
    }
  }
};
</script>